import React from 'react';
import './roomloadcomp.css';

const Roomloadcomp = (props) => {
    return (
        <div className='roomloaddiv'>
            <h4 className='leveltext'>{props.leveltext}</h4>
            <h4 className='roomname'>{props.levelname}</h4>
            <div className='roomdes'>
                <h4 className='dess'>{props.roomdes}</h4>
                <div className='roomdes2'>
                    <h4 className='missonobj'>{props.missonobj}</h4>
                    <div className='objlist'>
                        <h4 className='missonobj1'><span className='obj-dot' />{props.misson1}</h4>
                        <h4 className='missonobj1'><span className='obj-dot' />{props.misson2}</h4>
                        <h4 className='missonobj1'><span className='obj-dot' />{props.misson3}</h4>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Roomloadcomp;